import { createReducer } from "typesafe-actions";
import { fetchAllLogos, fetchAllLogosSuccess } from "./actions";
import { LogoState, LogoActions } from "./types";

export const initialState: LogoState = {
  loading: false,
  data: undefined,
  errors: undefined
};

type ActionType =
  | ReturnType<typeof fetchAllLogos>
  | ReturnType<typeof fetchAllLogosSuccess>;

export default createReducer<LogoState, ActionType>(initialState)
  .handleType(LogoActions.FETCH_ALL, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(LogoActions.FETCH_ALL_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined
    };
  });
